
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/getting-started/templates/profile-dashboard",
      function () {
        return require("private-next-pages/joy-ui/getting-started/templates/profile-dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/getting-started/templates/profile-dashboard"])
      });
    }
  